import { useEffect } from 'react';

import { Spin } from 'antd';
import { useIntersectionObserver } from 'hooks/reactuse';

import styles from './LoadMoreTrigger.module.css';

export const LoadMoreTrigger = ({ onInView }: { onInView: () => void }) => {
  const { ref, inView } = useIntersectionObserver<HTMLDivElement>({ threshold: 0.1 });

  useEffect(() => {
    if (inView) onInView();
  }, [inView]);

  return (
    <div ref={ref} className={styles.wrapper}>
      <Spin size={'small'} />
    </div>
  );
};
